export default __webpack_public_path__ + "static/media/467.5d27b3d5.jpg";